import React, { useEffect } from 'react'
import './index.scss'
import Header from '@shared/Header'
import Footer from '@shared/Footer'
import { Container } from 'react-bootstrap'
import ServicesOne from '@assets/images/services-one.jpg'
import ServiceArrowLeft from '@assets/images/left-down-arrow.png'
import ServiceArrowRight from '@assets/images/right-top.png'
import ServicesBgArrow from '@assets/images/services-bg-arrow.png'
import AccordionOne from '@assets/images/accordion-1.jpg'

const FAQPage = () => {
  const [activeAccordion, setActiveAccordion] = React.useState('1')
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <Header />
      <div className='faq-client'>
        <Container>
          <div className='pt-5'>
            <h1 className='services-title'>
            Empowering Clients, Streamlining Success
            </h1>
          </div>
          <div className='services-content'>
            
            <div className='services-content-item'>
              <div className='services-content-item__two'>

                <div
                  className='services-content-item__two-content three'
                  style={{ backgroundImage: `url(${ServiceArrowRight})` }}
                >
                  <h5>Tailored Engagement Options</h5>
                  <p>
                  Benefit from flexible engagement models designed to suit your project requirements.
                  </p>
                </div>
                <div className='services-content-item__two-content four top_pt'>
                  <h5>Network of Skilled Professionals</h5>
                  <p>
                  Discover a curated network of skilled experts across diverse domains.
                  </p>
                </div>
              </div>
            </div>
            
            <div className='services-content-item'>
              <div className='services-content-item__four'>
                {/* Accordion 1 */}
                <div className='accordion'>
                  <div
                    className='accordion-header'
                    onClick={() => setActiveAccordion('1')}
                  >
                    <p>
                      <span>01</span> How does Expert Bunch benefit clients?
                    </p>
                    <span>{activeAccordion === '1' ? '-' : '+'}</span>
                  </div>
                  {activeAccordion === '1' && (
                    <div className='accordion-body'>
                      <p className='accordion-body-text'>
                        <span>Ans.</span> - Access a curated network of skilled professionals in various domains. 
                        Enjoy flexible engagement options tailored to your project needs.
                      </p>
                    </div>
                  )}
                </div>

                {/* Accordion 2 */}
                <div className='accordion'>
                  <div
                    className='accordion-header'
                    onClick={() => setActiveAccordion('2')}
                  >
                    <p>
                      <span>02</span> What services can clients find on Expert Bunch?
                    </p>
                    <span>{activeAccordion === '2' ? '-' : '+'}</span>
                  </div>
                  {activeAccordion === '2' && (
                    <div className='accordion-body'>
                      <p className='accordion-body-text'>
                        <span>Ans.</span> - Find experts for software development, design, marketing, consulting, and more. 
                        Explore a wide range of industry-specific expertise to meet your specific requirements.
                      </p>
                    </div>
                  )}
                </div>

                {/* Accordion 3 */}
                <div className='accordion'>
                  <div
                    className='accordion-header'
                    onClick={() => setActiveAccordion('3')}
                  >
                    <p>
                      <span>03</span>  How are experts vetted on ExpertBunch?
                    </p>
                    <span>{activeAccordion === '3' ? '-' : '+'}</span>
                  </div>
                  {activeAccordion === '3' && (
                    <div className='accordion-body'>
                      <p className='accordion-body-text'>
                        <span>Ans.</span> - All experts undergo a rigorous vetting process to
                            ensure quality, experience, and reliability in their
                            respective fields.
                      </p>
                    </div>
                  )}
                </div>

                {/* Accordion 4 */}
                <div className='accordion'>
                  <div
                    className='accordion-header'
                    onClick={() => setActiveAccordion('4')}
                  >
                    <p>
                      <span>04</span> Can clients customize the engagement duration?
                    </p>
                    <span>{activeAccordion === '4' ? '-' : '+'}</span>
                  </div>
                  {activeAccordion === '4' && (
                    <div className='accordion-body'>
                      <p className='accordion-body-text'>
                        <span>Ans.</span> -  Yes, ExpertBunch offers both short- and
                              long-term engagement options, allowing clients to
                              scale their projects based on specific needs.
                      </p>
                    </div>
                  )}
                </div>
              
              </div>
            </div>
          </div>
        </Container>
      </div>
      <Footer />
    </>
  )
}

export default FAQPage
